import React, { FC } from 'react'
import Image from 'next/image'

import { ImageLinkProps } from '../A'
import ActionButton, { ActionButtonProps } from '../ActionButton'

import * as SC from './styled'

export type MenuSubItem = {
  name: string
  href: string
}

export type MenuItem = {
  name: string
  href: string
  subItems: MenuSubItem[]
}

export type FooterProps = {
  className?: string
  logos?: ImageLinkProps[]
  logoMain?: ImageLinkProps
  socials?: ActionButtonProps[]
  menu?: MenuItem[] | null
  legals?: { url?: string | null; ariaLabel: string }[]
}

const Footer: FC<FooterProps> = ({
  className,
  logos,
  logoMain,
  socials,
  legals,
  menu,
}) => {
  return (
    <>
      <SC.Container className={className}>
        <SC.Wrapper>
          <SC.Menu>
            {menu &&
              menu?.map((item, itemKey) => (
                <SC.MenuItem key={itemKey}>
                  <SC.MenuItemLink href={item.href}>
                    {item.name}
                  </SC.MenuItemLink>
                  <SC.MenuItemEntries>
                    {item?.subItems?.map((subItem, subItemKey) => (
                      <SC.MenuSubItem key={subItemKey} href={subItem.href}>
                        {subItem.name}
                      </SC.MenuSubItem>
                    ))}
                  </SC.MenuItemEntries>
                </SC.MenuItem>
              ))}
          </SC.Menu>
          <SC.Bottom>
            {logos && logos.length >= 1 && (
              <SC.Logos>
                {logos?.map((logo, index) => (
                  <SC.Logo
                    key={`logos-${index}`}
                    {...logo.linkProps}
                    width={logo.imageProps.width}
                  >
                    <Image {...logo.imageProps} />
                  </SC.Logo>
                ))}
              </SC.Logos>
            )}
            <SC.Main>
              {logoMain && (
                <SC.MainLogo>
                  <SC.Logo
                    {...logoMain.linkProps}
                    width={logoMain.imageProps.width}
                  >
                    <Image {...logoMain.imageProps} />
                  </SC.Logo>
                </SC.MainLogo>
              )}
              {socials && (
                <SC.Socials>
                  {socials.map((social, index) => (
                    <li key={`socials-${index}`}>
                      <ActionButton {...social} />
                    </li>
                  ))}
                </SC.Socials>
              )}
            </SC.Main>
          </SC.Bottom>
        </SC.Wrapper>
        {legals && (
          <SC.Legals>
            <SC.LegalsUl>
              {legals.map((item) => (
                <SC.LegalItem key={item.ariaLabel}>
                  <SC.LegalLink href={item.url || '!#'}>
                    {item.ariaLabel}
                  </SC.LegalLink>
                </SC.LegalItem>
              ))}
            </SC.LegalsUl>
          </SC.Legals>
        )}
      </SC.Container>
    </>
  )
}

export default Footer
